import React from 'react';

export const Button = ({ children, className = '', hoverClassName = 'hover:bg-gray-300', ...props }) => {
  // Vérifie si className contient déjà une classe hover, évite les conflits
  const finalHoverClass = className.includes('hover:bg-') ? '' : hoverClassName;

  return (
    <button {...props} className={`px-4 py-2 rounded ${className} ${finalHoverClass}`}>
      {children}
    </button>
  );
};
